import Connector, { takeQuery } from '../../agent';
import types from './types';

const CasNumbers = {
  getCasNumberList: () => Connector.api.get('/casNumbers/autocomplete')
};

const casNumberSagas = [takeQuery(types.GET_CAS_NUMBER_LIST, CasNumbers.getCasNumberList)];

export default casNumberSagas;
